// extracted by mini-css-extract-plugin
export default {"UploadBox":"UploadBox_UploadBox__43EfV","label":"UploadBox_label__JWIfG","icon":"UploadBox_icon__jD5yk","input":"UploadBox_input__GErtS","Namelabel":"UploadBox_Namelabel__D4zN-"};